"use client";

import type { MotionValue } from "framer-motion";
import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface FloatingCardProps {
	icon: ReactNode;
	title: string;
	subtitle?: string;
	className: string;
	rotate?: number;
	x: MotionValue<number>;
	y: MotionValue<number>;
	z: number;
}

/** Positioned notification-style card used for hero/marketing floating decorations. */
function FloatingCard(prop: FloatingCardProps) {
	const { icon, title, subtitle, className, rotate = 0, x, y, z } = prop;
	return (
		<motion.div className={cn("absolute z-20", className)} style={{ x, y, z }}>
			<div
				className="jana-float flex items-center gap-2 rounded-xl border border-border bg-surface px-2.5 py-2 shadow-(--shadow) sm:gap-2.5 sm:px-3 sm:py-2.5"
				style={{ transform: `rotate(${rotate}deg)` }}
			>
				<span className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-[color-mix(in_srgb,var(--brand-2)_16%,transparent)] text-(--brand-1) sm:h-8 sm:w-8">
					{icon}
				</span>
				<span className="whitespace-nowrap text-[11px] leading-tight sm:text-xs">
					<span className="block font-semibold text-text">{title}</span>
					{subtitle && <span className="block text-muted-foreground">{subtitle}</span>}
				</span>
			</div>
		</motion.div>
	);
}

export default FloatingCard;
